export default __webpack_public_path__ + "static/media/GCC_Playbook3.c52f1bdf.jpg";